import type { z } from "zod";
import { Agent } from "./agent";
import type { ToolCall } from "./message";
import type { ToolInterface } from "./tool";

export abstract class AgentTool extends Agent implements ToolInterface {
  public abstract readonly name: string;
  public abstract readonly description: string;
  public abstract readonly parameters: z.ZodTypeAny;

  public abstract executeTool(args: any, toolCall: ToolCall): Promise<any>;
}
